var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('IxVectorLayer',{attrs:{"features":_vm.featureAbLines,"vector-style":_vm.style,"layer-id":"ab-lines"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }